import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const efficiencyRatiosAC: CriterionType[] = [
  {
    id: 'FIN-10',
    label: 'Current ratio',
    shortLabel: 'CurrRt',
    group: AC_GROUPS.efficiencyRatios,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'EFF-10',
    label: 'Inventory turnover',
    shortLabel: 'InvTurn',
    group: AC_GROUPS.efficiencyRatios,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'EFF-20',
    label: 'Receivables turnover',
    shortLabel: 'RecTurn',
    group: AC_GROUPS.efficiencyRatios,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'EFF-30',
    label: 'Asset turnover',
    shortLabel: 'AssetTurn',
    group: AC_GROUPS.efficiencyRatios,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'EFF-40',
    label: 'Cash conversion cycle (Days)',
    shortLabel: 'CashCycle(D)',
    group: AC_GROUPS.efficiencyRatios,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default efficiencyRatiosAC;
